import { checklistForm } from "./ChecklistForm";

export default class Checklist {
  static getChecklistForm() {
    return checklistForm;
  }
}
